import markdownit from 'markdown-it';
import DomPurify from 'dompurify';

const mdInstance = markdownit({
	html: true,
	linkify: true,
	typographer: true
});

mdInstance.linkify.set({
	fuzzyIP: false,
	fuzzyEmail: true,
	fuzzyLink: true,
});

// Remember the old renderer if overridden, or proxy to the default renderer.
const defaultRender = mdInstance.renderer.rules['link_open'] || function (tokens, idx, options, env, self) {
	return self.renderToken(tokens, idx, options);
};

mdInstance.renderer.rules['link_open'] = function (tokens, idx, options, env, self) {
	// Add a new `target` attribute, or replace the value of the existing one.
	tokens[idx].attrSet('target', '_blank');
	tokens[idx].attrSet('rel', 'noopener noreferrer');

	// Pass the token to the default renderer.
	return defaultRender(tokens, idx, options, env, self);
};

export const  createAndSanitizeMarkdown = (input: string): { __html: string } => {
	const dirtyHtml = mdInstance.render(input);
	const sanitized = DomPurify.sanitize(dirtyHtml, { ADD_ATTR: ['target', 'rel'] });

	return { __html: sanitized };
}
